import React, { useEffect } from "react";
import styles from "./policy-modal.module.scss";

interface PolicyModalProps {
  title: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const PolicyModal: React.FC<PolicyModalProps> = ({ title, open, onClose, children }) => {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.style.overflow = "auto";
    };
  }, [open, onClose]);

  if (!open) return null;

  const onBackdrop = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  const onContent = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.backdrop} onClick={onBackdrop} role="dialog" aria-modal="true" aria-labelledby="policy-title">
      <div className={styles.modal} onClick={onContent}>
        <div className={styles.header}>
          <h2 id="policy-title" className={styles.title}>{title}</h2>
          <button className={styles.close} onClick={onClose} aria-label="Sluiten">×</button>
        </div>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default PolicyModal;
